import { Flex } from "~/components/Flex";
import { ConditionBuilderAddSelectionRow } from "~/components/ConditionBuilder/ConditionBuilderSelectionRow/ConditionBuilderAddSelectionRow";
import { useWorkspaceConditionBuilder } from "~/pages/space/workspaces/components/ConditionBuilder/hooks/useWorkspaceConditionBuilder";
import { WorkspaceConditionSelectionRow } from "./components/ConditionSelectionRow/WorkspaceConditionSelectionRow";

interface WorkspaceConditionBuilderProps {
  isReadonly?: boolean;
  showFormActions?: boolean;
}

export const WorkspaceConditionBuilder = ({
  isReadonly = false,
  showFormActions,
}: WorkspaceConditionBuilderProps) => {
  const {
    fields,
    handleRemoveSelection,
    handleAddNewSelection,
    canAddSelection,
  } = useWorkspaceConditionBuilder();

  return (
    <Flex flexDirection="column" gap={3}>
      {fields.map((_field, selectionIndex) => (
        <WorkspaceConditionSelectionRow
          selectionIndex={selectionIndex}
          onRemove={() => handleRemoveSelection(selectionIndex)}
          showRemoveSelectionButton={selectionIndex !== 0 && !isReadonly}
          key={_field.id}
          isReadonly={isReadonly}
        />
      ))}
      {!isReadonly && (
        <ConditionBuilderAddSelectionRow
          onClick={handleAddNewSelection}
          disabled={!canAddSelection}
          showFormActions={showFormActions}
        />
      )}
    </Flex>
  );
};
